import type { User } from '@shared/types';
import { filterLoginTypes, toRole } from '@shared/enums';
import type { UserUser } from '@/api';

// UserResponse в OpenAPI не содержит Rank/RankRejected — бэкенд их возвращает,
// но в схему пока не добавлены. Поэтому принимаем расширенный тип.
type UserResponseExt = UserUser & {
    rank?: string;
    rankRejected?: boolean;
};

export const mapUserResponseToUser = (resp: UserUser): User => {
    const r = resp as UserResponseExt;
    return {
        ID: resp.id || '',
        Name: resp.name || '',
        Username: resp.userName || '',
        Avatar: resp.pictureUrl || '',
        AvatarRevision: resp.lastUpdate || '',
        EMail: resp.email || resp.emails?.[0] || '',
        Emails: resp.emails || (resp.emails ? [resp.emails] : []),
        LoginTypes: filterLoginTypes(resp.loginTypes ?? []),
        Roles: (resp.roles ?? []).filter(toRole),
        ConsentDate: resp.consentDate || '',
        FirstName: resp.firstName || '',
        LastName: resp.lastName || '',
        MiddleName: resp.middleName || '',
        LastUpdate: resp.lastUpdate || '',
        Rank: r.rank || '',
        PlayerId: resp.playerId || '',
        Location: resp.location || 0,
        Birthday: resp.birthday || '',
        RankRejected: r.rankRejected ?? false,
    };
};
